import { listConceptRelations } from 'api-proxy/external/listConceptRelations';
import { ApiConcept, ApiConceptRelation } from 'types/swagger/clarifai-api';

export type ConceptCreateResponse = {
  isExisting: boolean;
  concept: ApiConcept;
};

export type FetchAllConceptRelationsRequest = {
  request: {
    userOrOrgId: string;
    appId: string;
  };
};

const PER_PAGE = 512;

// Public Endpoint to use in the app
export const fetchAllConceptRelations = async ({
  request: { userOrOrgId, appId },
}: FetchAllConceptRelationsRequest): Promise<ApiConceptRelation[] | null> => {
  if (!userOrOrgId || !appId) return null;

  let page = 1;
  let conceptRelations = [] as ApiConceptRelation[];

  const loopFetchAll = async () => {
    const currentPage = await listConceptRelations({
      userOrOrgId,
      appId,
      page,
      perPage: PER_PAGE,
    });

    if (currentPage) {
      conceptRelations = [...conceptRelations, ...currentPage];

      if (currentPage.length === PER_PAGE) {
        page += 1;
        return loopFetchAll();
      }
    }
    return true;
  };

  const isFetched = await loopFetchAll();

  if (isFetched) {
    return conceptRelations;
  } else {
    throw new Error('Cannot excete fetchAllConceptRelations');
  }
};
